// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"style_dropdown__wzk3e","icon":"style_icon__lJlrn"};